<template>
  <el-dialog
    title="大神码下载记录"
    :visible.sync="dialogVisible"
    width="1400px"
  >
    <div class="download-record-dialog">
      <div class="download-record-toolbar">
        <span>大神码</span>
        <el-input
          v-model="code"
          clearable
          size="small"
          placeholder="请输入大神码"
          @keyup.enter.native="handleSearch"
        ></el-input>
        <el-button type="primary" size="small" @click="handleSearch">
          搜索
        </el-button>
        <el-button
          size="small"
          :loading="exportLoading"
          @click="exportRecords"
        >
          导出Excel
        </el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        size="small"
        style="width: 100%"
      >
        <el-table-column prop="code" label="大神码" width="100"></el-table-column>
        <el-table-column prop="name" label="应用名称" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pkg" label="应用包名" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="creatorUid" label="创建人uid" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="creatorPhone" label="创建人手机号" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="creatorEmail" label="创建人邮箱" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="userUid" label="下载人uid" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="userId" label="下载人id" width="110"></el-table-column>
        <el-table-column prop="mac" label="下载人mac" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="下载时间" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.downloadedAt) }}
          </template>
        </el-table-column>
      </el-table>
      <div class="download-record-pagination">
        <Pagination
          :pageSize="params.limit"
          :currentPage="params.page"
          :pageSizes="true"
          :total="total"
          @pageNum="pageNum"
          @pageSize="pageSize"
        />
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Pagination from "@/components/pagination";

export default {
  name: "DownloadRecordDialog",
  components: {
    Pagination,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      exportLoading: false,
      code: "",
      tableData: [],
      total: 0,
      params: {
        page: 1,
        limit: 20,
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.reset();
        this.fetchRecords();
      }
    },
  },
  methods: {
    reset() {
      this.code = "";
      this.params.page = 1;
    },

    buildParams(includePagination = true) {
      const params = {};
      if (includePagination) {
        params.page = this.params.page;
        params.limit = this.params.limit;
      }
      if (this.code) {
        params.code = this.code;
      }
      return params;
    },

    async fetchRecords() {
      this.loading = true;
      try {
        const res = await this.$http.getGodCodeDownloadRecords(
          this.buildParams()
        );
        this.total = res.data.count;
        this.tableData = res.data.results.map(item => {
          const appConf = item.appConf || {};
          return {
            ...item,
            code: appConf.code || "-",
            name: appConf.name || "-",
            pkg: appConf.pkg || "-",
            creatorUid: appConf.uid || "-",
            creatorPhone: appConf.ownerPhone || "-",
            creatorEmail: appConf.ownerEmail || "-",
            userUid: item.userUid || "-",
            userId: item.userId || "-",
            mac: item.mac || "-",
          };
        });
      } catch (error) {
        this.elMsg("获取下载记录失败", "error");
      } finally {
        this.loading = false;
      }
    },

    handleSearch() {
      this.params.page = 1;
      this.fetchRecords();
    },

    pageNum(val) {
      this.params.page = val;
      this.fetchRecords();
    },

    pageSize(size) {
      this.params.limit = size;
      this.params.page = 1;
      this.fetchRecords();
    },

    async exportRecords() {
      this.exportLoading = true;
      try {
        const res = await this.$http.exportGodCodeDownloadRecords(
          this.buildParams(false)
        );
        const blob = new Blob([res], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const now = new Date();
        const dateStr = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;
        link.download = `大神码下载记录_${dateStr}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.elMsg("导出下载记录失败", "error");
      } finally {
        this.exportLoading = false;
      }
    },

    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleString("zh-CN");
    },
  },
};
</script>

<style lang="scss" scoped>
.download-record-dialog {
  .download-record-toolbar {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;

    .el-input {
      width: 220px;
    }
  }

  .download-record-pagination {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
